import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../../../core/i18n';
import { LaunchDialogService } from '../../../../../core/modal';
import { ActionButtonModule } from '../../../../../shared/components/action-button';
import { ModalModule } from '../../../../../shared/components/modal';
import { ReactiveFormCheckboxSliderModule } from '../../../../../shared/components/reactive-forms-input/reactive-form-checkbox-slider/reactive-form-checkbox-slider.module';
import { exportShoppingListModalLayoutConfig } from './export-shopping-list-modal-layout.config';
import { ExportShoppingListModalComponent } from './export-shopping-list-modal.component';

@NgModule({
  declarations: [ExportShoppingListModalComponent],
  imports: [
    CommonModule,
    I18nModule,
    ModalModule,
    ActionButtonModule,
    ReactiveFormCheckboxSliderModule,
    NzIconModule,
    KeyboardFocusModule,
  ],
  exports: [ExportShoppingListModalComponent],
})
export class ExportShoppingListModalModule {
  constructor(private launchDialogService: LaunchDialogService) {
    this.launchDialogService.registerModalLayoutConfig(exportShoppingListModalLayoutConfig);
  }
}
